import request from "@/api/axios";

// 获取产品系列
export function getSeriesList() {
	return request({
		url: `/serie/list`,
		method: 'get'
	});
}
// 获取系列信息
export function getSeriesInfo(id){
    return request({
		url: `/product/detail/${id}`,
		method: 'get'
	});
}
// 获取系列颜色 
export function getSeriesColor(params){
    return request({
		url: `serie/${params.id}/product/${params.colorId}`,
		method: 'get'
	});
}

// 选择产品
export function choseProduct(params){
    return request({
		url: `/serie/product/${params.id}`,
        method: 'get',
        params
	});
}
// 添加购物车
export function addShopCart(data){
    return request({
		url: `/cart/add`,
        method: 'put',
        data
	});
}
